export const stripHtml = (html: string): string => {
    const tmpDoc = new DOMParser().parseFromString(html, 'text/html');

    return tmpDoc.body.textContent ?? tmpDoc.body.innerText;
};

export const decodeHtmlEntities = (value: string): string => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;

    return textarea.value;
};
